export const STEP_ICONS = [
  'icon-atom',
  'icon-components',
  'icon-money-coins',
  'icon-notes'
];
